import RolesManagement from "../features/roles/RolesManagement";

export default function RolesPage() {
  return <RolesManagement />;
}
